import React from 'react';
import {ThreeDots} from "react-loader-spinner";

class SpinnerComponent extends React.Component {
	state = {
		loading: true
	};
	render() {
		return (
			<div className="sweet-loading">
				<ThreeDots
					type="ThreeDots"
					color={"#FF586B"}
				/>
			</div>
		);
	}
}

export default SpinnerComponent;